import { useQuery } from '@tanstack/react-query';
import { getRegions } from 'API/Region/getRegions';

/**
 * Custom hook for fetching and caching regions data
 * Shared across Add and Edit components with automatic caching
 */
const useRegions = () => {
    return useQuery({
        queryKey: ['regions'],
        queryFn: getRegions,
        staleTime: 10 * 60 * 1000, // 10 minutes - regions change infrequently
        cacheTime: 15 * 60 * 1000, // 15 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
};

export default useRegions;
